import { TALENTS } from '@/models/talents';
import { TalentManager } from '@/systems/TalentManager';

export class TalentPanel {
  private container: HTMLElement;
  private shardCountEl: HTMLElement;
  private cardEls: Map<string, { buyBtn: HTMLButtonElement; levelEl: HTMLElement }> = new Map();
  private talentManager: TalentManager;
  private onPurchase: (() => void) | null = null;

  constructor(parent: HTMLElement, talentManager: TalentManager, onPurchase?: () => void) {
    this.talentManager = talentManager;
    this.onPurchase = onPurchase ?? null;

    this.container = document.createElement('div');
    this.container.id = 'talent-panel';
    this.container.className = 'game-panel';

    this.container.innerHTML = `
      <div class="game-panel-header">
        <div class="game-panel-title">ARCANE TALENTS</div>
        <button class="game-panel-close">&times;</button>
      </div>
      <div class="shard-count" id="talent-shard-count">💠 0 Shards</div>
      <div id="talent-grid"></div>
    `;

    this.shardCountEl = this.container.querySelector('#talent-shard-count')!;
    const grid = this.container.querySelector('#talent-grid')!;

    for (const talent of TALENTS) {
      const card = document.createElement('div');
      card.className = 'talent-card';
      card.dataset.id = talent.id;

      const icon = document.createElement('div');
      icon.className = 'talent-icon';
      icon.textContent = talent.icon;

      const info = document.createElement('div');
      info.className = 'talent-info';

      const name = document.createElement('div');
      name.className = 'talent-name';
      name.textContent = talent.name;

      const desc = document.createElement('div');
      desc.className = 'talent-desc';
      desc.textContent = talent.description;

      const levelEl = document.createElement('div');
      levelEl.className = 'talent-level';
      levelEl.textContent = `0 / ${talent.maxLevel}`;

      info.appendChild(name);
      info.appendChild(desc);
      info.appendChild(levelEl);

      const buyBtn = document.createElement('button');
      buyBtn.className = 'btn btn-upgrade';
      buyBtn.textContent = `${talent.shardCost} 💠`;
      buyBtn.addEventListener('click', () => this.onBuy(talent.id));

      card.appendChild(icon);
      card.appendChild(info);
      card.appendChild(buyBtn);
      grid.appendChild(card);

      this.cardEls.set(talent.id, { buyBtn, levelEl });
    }

    this.container.querySelector('.game-panel-close')!.addEventListener('click', () => this.hide());
    parent.appendChild(this.container);

    this.refresh();
  }

  private onBuy(id: string): void {
    if (this.talentManager.purchaseTalent(id)) {
      this.onPurchase?.();
    }
    this.refresh();
  }

  refresh(): void {
    const shards = this.talentManager.getShards();
    this.shardCountEl.textContent = `💠 ${shards} Shards`;

    for (const talent of TALENTS) {
      const els = this.cardEls.get(talent.id);
      if (!els) continue;
      const level = this.talentManager.getTalentLevel(talent.id);
      const atMax = level >= talent.maxLevel;
      const canAfford = shards >= talent.shardCost;

      els.levelEl.textContent = `${level} / ${talent.maxLevel}`;
      els.buyBtn.disabled = atMax || !canAfford;
      els.buyBtn.textContent = atMax ? 'MAX' : `${talent.shardCost} 💠`;
    }
  }

  show(): void { this.container.style.display = 'block'; this.refresh(); }
  hide(): void { this.container.style.display = 'none'; }
  toggle(): void {
    this.container.style.display === 'none' ? this.show() : this.hide();
  }
  destroy(): void { this.container.remove(); }
}
